module.exports = __webpack_public_path__ + "static/media/method-1a-mob.f96c7414.png";